<template>
  <div class="box">
    <a-drawer
      :title="title"
      width="87vw"
      :visible="visible"
      :maskClosable="false"
      :mask="false"
      :confirmLoading="confirmLoading"
      :wrapClassName="wrapClassNameInfo()"
      @ok="handleOk"
      @close="handleCancel"
      cancelText="取消"
      okText="保存"
      :destroyOnClose="true"
      >
      <a-row :gutter="24">
      <a-col :md="24">
        <a-card>
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
                <a-col :md="8">
                  <a-form-item label="节点名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入节点名称查询" v-model="queryParam.nodeName"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8">
                  <a-form-item label="节点编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入节点编码查询" v-model="queryParam.nodeCode"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8">
                  <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-col :md="6" :sm="24">
                      <a-button type="primary" @click="searchQuery2">查询</a-button>
                      <a-button style="margin-left: 8px" @click="searchReset2">重置</a-button>
                    </a-col>
                  </span>
                </a-col>
            </a-form>
          </div>
          <!-- 操作按钮区域 -->
          <div class="table-operator"  style="margin-top: 5px">
            <a-button @click="handleAdd({ruleId: ruleId})" type="primary" icon="plus">新增</a-button>
            <a-button @click="batchDel(ruleId)" icon="delete">删除</a-button>
          </div>

          <!-- table区域-begin -->
          <div style="margin-bottom: 10%;">
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="nodeId"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.nodeId, ruleId)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <!-- 状态渲染模板 -->
              <template slot="customRenderFlag" slot-scope="enabled">
                <a-tag v-if="enabled==1" color="green">启用</a-tag>
                <a-tag v-if="enabled==0" color="orange">禁用</a-tag>
              </template>
            </a-table>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button key="back" v-if="isReadOnly" @click="handleCancel">
        取消
      </a-button>
    </template>
    </a-drawer>

    <!-- 新增/编辑区域 -->
    <ruleNode-modal ref="modalForm" @ok="modalFormOk"></ruleNode-modal>

    <!-- 新增/编辑区域 -->
    <!-- <a-modal v-model="visible" title="新增" @ok="modalFormOk" width="50vw">
      <RuleNodeModal></RuleNodeModal>
    </a-modal> -->

  </div>
</template>

<script>
  import pick from 'lodash.pick'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {mixinDevice} from '@/utils/mixin'
  import RuleNodeModal from './ruleNodeModal.vue';
  import { ruleNodeList } from '@/api/identifierCode/identifierCode'
  import {autoJumpNextInput} from "@/utils/util"
  export default {
    name: "list",
    mixins:[JeecgListMixin,mixinDevice],
    components: {
      RuleNodeModal,
      JSelectMultiple
    },
    props: {
      // uuid: { type: Array, required: true }
    },
    data() {
      return {
        qve:'',
        qve2:'',
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },
        ruleId: null,

        // 查询条件
        queryParam: {
          ruleId: ''
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width: '5%',
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '30%',
            align:"center",
            scopedSlots: { customRender: 'action' },
          },
          {title: '节点名称 ', dataIndex: 'nodeName', width: 80},
          {title: '节点编码 ', dataIndex: 'nodeCode', width: 80},
          {title: '节点前置分隔符 ', dataIndex: 'delimiterLabel', width: 80},
          {title: '节点长度 ', dataIndex: 'nodeLength', width: 80},
          // {title: '备注', dataIndex: 'remark', width: 80},
          {title: '更新时间 ', dataIndex: 'updateTime', width: 80},
        ],
        url: {
          list: "/codeRules/fzRuleNode/list",
          delete: "/codeRules/fzRuleNode/delete",
          deleteBatch: "/codeRules/fzRuleNode/deleteBatch"
        },
        visibleRuleNode: false, // 规则节点抽屉开关

        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{

        },
      }
    },
    methods: {
      onChange(checked) {
        this.model.enabled = checked
      },
      add (qve) {
        console.log('拿到了没？', qve)
        this.queryParam.ruleId = qve
        this.ruleId = qve
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
        this.visible = true;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.id){
          this.jselectMultiple.value = record.pushBtn
        } else {
          this.jselectMultiple.value = ''
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'number', 'name', 'parentNumber', 'parentName', 'url', 'component', 'sort', 'pushBtn', 'icon', 'enabled'))
          autoJumpNextInput('functionModal')
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      showModal() {
        console.log('===')
        this.visible = true;
      },
      handleOk(e) {
        console.log(e);
        this.visible = false;
      },
      hh() {
        this.$refs.functionTreeModal.edit(this.model.id);
        this.$refs.functionTreeModal.title = "选择上级编号";
        this.$refs.functionTreeModal.disableSubmit = false;
      },
      getList(qve, qve2) {
        this.qve = qve
        this.qve2 = qve2

        if ( !qve2 ) {
          this.ruleId = qve

          let pageNo = this.ipagination.current
          let pageSize = this.ipagination.pageSize
          ruleNodeList({ruleId: this.ruleId, pageNo: pageNo, pageSize: pageSize})
          .then(res => {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          })

          this.visible = true
        } else {
          qve2.ruleId = qve
          qve2.pageNo = this.ipagination.current
          qve2.pageSize = this.ipagination.pageSize
          ruleNodeList(qve2)
          .then(res => {
            this.dataSource = res.result.records
          })
        }
      },
      handleCancel () {
        this.close()
      },
      searchReset2() {
        this.queryParam = {}
        this.getList(this.ruleId)
      },
      searchQuery2() {
        this.getList(this.ruleId, this.queryParam)
      }
    },
    created() {
      console.log('你')
    }
  }
</script>

<style scoped>
  @import '~@assets/less/common.less'
</style>